import React, {useMemo, useState} from "react";
import {useDispatch} from "react-redux";
import {Link, useNavigate} from "react-router-dom";
import ConfirmModal from "../../Components/Common/ConfirmModal";
import {importMenu} from "../../helpers/backend_helper";
import {showAlertWithTimeout} from "../../slices/Alert/reducer";
import type {AppDispatch} from "../../store";
import HeaderSidebarToggle from "../../Components/Common/HeaderSidebarToggle";
import HomeLogoLink from "../../Components/Common/HomeLogoLink";
const MenuImport = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const [payloadText, setPayloadText] = useState("");
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const isImportDisabled = useMemo(() => payloadText.trim().length === 0 || isSubmitting, [
        payloadText,
        isSubmitting,
    ]);

    const handleOpenConfirm = () => {
        if (payloadText.trim().length === 0) {
            dispatch(showAlertWithTimeout("warning", "Thiếu dữ liệu", "Vui lòng nhập JSON để nhập hàng loạt."));
            return;
        }
        setIsConfirmOpen(true);
    };

    const handleCloseConfirm = () => {
        setIsConfirmOpen(false);
    };

    const handleImport = async () => {
        setIsSubmitting(true);
        setIsConfirmOpen(false);

        try {
            let parsed;
            try {
                parsed = JSON.parse(payloadText);
            } catch (parseError) {
                dispatch(
                    showAlertWithTimeout("danger", "JSON không hợp lệ", "Vui lòng kiểm tra lại định dạng JSON.")
                );
                return;
            }
            await importMenu(parsed);
            dispatch(
                showAlertWithTimeout("success", "Nhập thành công", "Menu đã được nhập hàng loạt thành công.")
            );
            setPayloadText("");
            navigate("/menu");
        } catch (error: any) {
            const message =
                error?.message ||
                error?.errors?.message ||
                "Không thể nhập hàng loạt menu. Vui lòng kiểm tra dữ liệu.";
            dispatch(showAlertWithTimeout("danger", "Nhập thất bại", message));
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <React.Fragment>
            <div className="header-area" id="headerArea">
                <div
                    className="container h-100 d-flex text-center align-items-center justify-content-between rtl-flex-d-row-r">
                    <HomeLogoLink className="me-2"/>

                    <div className="page-heading">
                        <h6 className="mb-0">Nhập hàng loạt</h6>
                    </div>

                    <HeaderSidebarToggle className="ms-2"/>
                </div>
            </div>
            <div className="page-content-wrapper">
                <div className="container p-2">
                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                        <div>
                            <p className="mb-1 text-muted">
                                Dán JSON để nhập hàng loạt menu, hệ thống sẽ xóa toàn bộ menu hiện tại trước khi
                                tạo mới.
                            </p>
                            <p className="mb-0 text-muted">
                                <Link to="/contact">Liên hệ admin</Link> để hỗ trợ nhập toàn bộ menu nhanh chóng.
                            </p>
                        </div>
                        <button
                            className="btn btn-danger"
                            type="button"
                            onClick={handleOpenConfirm}
                            disabled={isImportDisabled}
                        >
                            {isSubmitting ? "Đang nhập..." : "Nhập hàng loạt"}
                        </button>
                    </div>

                    <textarea
                        className="form-control"
                        value={payloadText}
                        onChange={(event) => setPayloadText(event.target.value)}
                        placeholder="Dán JSON menu tại đây..."
                        style={{height: "calc(100vh - 320px)"}}
                    />

                    <ConfirmModal
                        isOpen={isConfirmOpen}
                        typeConfirm="danger"
                        title="Xác nhận nhập hàng loạt menu"
                        content="Nhập hàng loạt sẽ xóa toàn bộ danh mục và menu hiện tại. Bạn có chắc chắn muốn tiếp tục?"
                        onConfirm={handleImport}
                        onCancel={handleCloseConfirm}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

export default MenuImport;
